import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Preload routes marked with preload: true
    if (route.data && route.data['preload']) {
      return load();
    }
    
    // Preload critical routes after a delay
    if (route.path === 'dashboard' || route.path === 'login') {
      return load();
    }
    
    // Don't preload other routes
    return of(null);
  }
}
